<template>
  <div class="vx-row">
    <vs-card>
      <!-- <div slot="header">
        <h5>Statistique des demandes</h5>
      </div> -->
      <vs-row>
        <vs-col>
          <div class="flex -mx-2">
            <div class="w-1/5 px-2">
              <p class="mt-1">Service</p>
              <v-select
                :reduce="(rep) => rep.id"
                class="w-full"
                label="name"
                v-model="departement"
                :options="departements"
              ></v-select>
            </div>
            <div class="w-2/5 px-2">
              <span class="vs-select--label">Période</span>
              <date-range-picker
                ref="picker"
                :opens="opens"
                :locale-data="locale"
                :singleDatePicker="false"
                :timePicker="false"
                :showWeekNumbers="showWeekNumbers"
                :showDropdowns="showDropdowns"
                :autoApply="autoApply"
                v-model="dateRange"
                :ranges="false"
                @update="updateValues"
                :linkedCalendars="linkedCalendars"
                :dateFormat="dateFormat"
                :always-show-calendars="false"
                :alwaysShowCalendars="alwaysShowCalendars"
                class="vs-inputx vs-input--input"
              >
                <div slot="input" slot-scope="picker" style="min-width: 350px">
                  {{ picker.startDate | date }} - {{ picker.endDate | date }}
                </div>
              </date-range-picker>
            </div>
            <div class="w-1/5 px-2">
              <vs-button
                :disabled="
                  dateRange.startDate === '' && dateRange.endDate === ''
                "
                @click="getStat()"
                style="margin-top: 18px"
                color="primary"
                type="filled"
                icon="cloud_download"
                >Exporter
              </vs-button>
            </div>
          </div>
        </vs-col>
      </vs-row>
      <!-- <vs-divider></vs-divider> -->
    </vs-card>
  </div>
</template>
<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from "moment";
import axios from "axios";
export default {
  name: "servicePeriod",
  components: { DateRangePicker },
  data: () => ({
    categories: [],
    user: 0,
    category: "",
    stats: [],
    requests: [],
    last_page: null,
    page: 1,
    opens: "center",
    showWeekNumbers: true,
    linkedCalendars: true,
    alwaysShowCalendars: true,
    showDropdowns: true,
    autoApply: false,
    locale: {
      direction: "ltr",
      format: "dd/mm/yyyy",
      separator: " - ",
      applyLabel: "Appliquer",
      cancelLabel: "Annuler",
      weekLabel: "W",
      customRangeLabel: "Custom Range",
      daysOfWeek: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
      monthNames: [
        "Jan",
        "Fev",
        "Mar",
        "Avr",
        "Mai",
        "Jui",
        "Juil",
        "Aou",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      firstDay: 0,
    },
    dateRange: {
      startDate: "",
      endDate: "",
    },
    departements: [],
    departement: ""
  }),
  mounted() {
    this.dateRange.startDate = moment(new Date()).format("YYYY-MM-DD");
    this.dateRange.endDate = moment(new Date()).format("YYYY-MM-DD");
    // this.getCategories();
    this.getDepartements();
  },
  methods: {
    updateValues(values) {
      this.dateRange.startDate = moment(values.startDate).format("YYYY-MM-DD");
      this.dateRange.endDate = moment(values.endDate).format("YYYY-MM-DD");
    },
    dateFormat(classes, date) {
      let yesterday = moment().subtract(1, "day");
      if (!classes.disabled) {
        //classes.disabled = moment(date).isSame(yesterday, 'day')
      }
      return classes;
    },
    getCategories() {
      this.$vs.loading();
      this.$http
        .get("/categories-requests?paginate=0")
        .then((response) => {
          this.categories = response.data;
          this.$vs.loading.close();
        })
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        });
    },
    async getDepartements() {
      try {
        this.$vs.loading();
        let response = await this.$http.get("departements");
        this.departements = response.data;
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading();
        console.log(error);
      }
    },

    getStat() {
      this.$vs.loading();
      axios({
        url: "/ebu/report-period?export=1",
        method: "POST",
        data: {
          departement_id: this.departement,
          date_debut: this.dateRange.startDate,
          date_fin: this.dateRange.endDate,
        },
        responseType: "blob",
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "stats_par_service_et_par_periode.xlsx");
          document.body.appendChild(link);
          link.click();
          this.departement = "";
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.error_base = error.response.data.errors;
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$vs.notify({
              title: "Erreur",
              text: "Votre session a expiré",
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.$router.push({ name: "login" });
          }
        });
    },
  },
};
</script>
<style scoped>
.bar {
  border-left: 1px solid #626262;
  height: 350px;
  opacity: 0.2;
}
</style>
